import { useTranslation } from 'react-i18next';
import { BRAND, SOCIAL } from './data';
import { ContactForm } from './ContactForm';
import { Marquee } from './Marquee';

export const CTAContact = () => {
  const { t } = useTranslation();
  const labels = t('contact.labels', { returnObjects: true }) || {};
  const placeholders = t('contact.placeholders', { returnObjects: true }) || {};

  return (
    <>
      <Marquee items={t('cta.marqueeItems', { returnObjects: true }) || []} />

      <section id="contact" className="relative border-b border-ink py-20 md:py-28" data-testid="contact-section">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="flex items-center gap-3 mb-8">
            <span className="font-mono text-xs bg-ink text-page px-2 py-1 tracking-widest2">§ 06</span>
            <span className="font-mono uppercase text-xs tracking-widest2 text-ink">{t('cta.eyebrow')}</span>
          </div>

          <div className="grid grid-cols-12 gap-8 md:gap-12 mb-12 md:mb-14">
            <div className="col-span-12 lg:col-span-8">
              <h2 className="display text-6xl md:text-7xl lg:text-8xl leading-[0.9] text-ink">
                {t('cta.h1_pre')}<br />
                <span className="serif-italic">{t('cta.h1_italic')}</span>{' '}
                <span
                  className="inline-block px-2 md:px-3 text-ink"
                  style={{ background: '#D0FF3F' }}
                >
                  {t('cta.h1_hl')}
                </span>
              </h2>
            </div>
            <div className="col-span-12 lg:col-span-4 lg:pt-6">
              <p className="serif-italic text-lg md:text-xl leading-snug text-ink/85">
                {t('cta.lede')}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-12 gap-8 md:gap-10">
            {/* Form */}
            <div className="col-span-12 lg:col-span-8">
              <ContactForm t={t} labels={labels} placeholders={placeholders} />
            </div>

            {/* Side details */}
            <aside className="col-span-12 lg:col-span-4 flex flex-col gap-4">
              <div className="box-line p-6">
                <p className="font-mono uppercase text-[10px] tracking-widest2 text-ink/60 mb-2">— {t('cta.emailLabel')}</p>
                <a
                  href={`mailto:${BRAND.email}`}
                  className="font-mono text-sm text-ink hover:text-clay transition-colors break-all"
                  data-testid="contact-direct-email"
                >
                  {BRAND.email}
                </a>
              </div>
              <div className="box-line p-6 bg-ink text-page">
                <p className="font-mono uppercase text-[10px] tracking-widest2 text-lime mb-2">— {t('cta.hoursLabel')}</p>
                <p className="font-mono uppercase text-sm text-page leading-snug">{t('cta.hoursText')}</p>
              </div>
              <div className="box-line p-6">
                <p className="font-mono uppercase text-[10px] tracking-widest2 text-ink/60 mb-3">— {t('cta.elsewhereLabel')}</p>
                <ul className="space-y-2">
                  <li>
                    <a href={SOCIAL.linkedin} target="_blank" rel="noreferrer" className="font-mono uppercase text-xs tracking-widest text-ink link-underline">
                      LinkedIn ↗
                    </a>
                  </li>
                  <li>
                    <a href={SOCIAL.x} target="_blank" rel="noreferrer" className="font-mono uppercase text-xs tracking-widest text-ink link-underline">
                      X (Twitter) ↗
                    </a>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
};
